import { apiClient } from "./client";

/**
 * Response from BC opportunities API
 */
export interface BCOpportunity {
  "@odata.etag"?: string;
  no: string;
  siteAddress?: string;
  description?: string;
  salespersonCode?: string;
  campaignNo?: string;
  contactNo?: string;
  contactCompanyNo?: string;
  salesCycleCode?: string;
  salesDocumentNo?: string;
  creationDate?: string;
  status?: string;
  priority?: string;
  closed?: boolean;
  dateClosed?: string;
  noSeries?: string;
  comment?: boolean;
  currentSalesCycleStage?: number;
  estimatedValueLCY?: number;
  probability?: number;
  calcdCurrentValueLCY?: number;
  chancesOfSuccess?: number;
  completed?: number;
  contactName?: string;
  contactCompanyName?: string;
  salespersonName?: string;
  campaignDescription?: string;
  segmentNo?: string;
  estimatedClosingDate?: string;
  salesDocumentType?: string;
  noOfInteractions?: number;
  coupledToDataverse?: boolean;
  wizardStep?: string;
  activateFirstStage?: boolean;
  segmentDescription?: string;
  wizardEstimatedValueLCY?: number;
  wizardChancesOfSuccess?: number;
  wizardEstimatedClosingDate?: string | null;
  wizardContactName?: string;
  wizardCampaignDescription?: string;
  region?: string;
}

/**
 * Response from opportunities API
 */
export interface OpportunitiesResponse {
  value?: BCOpportunity[];
  data?: BCOpportunity[];
  opportunities?: BCOpportunity[];
}

export interface CloseOpportunityPayload {
  actionTaken: string;
  closeOpportunityCode: string;
  closingDate: string;
  salesLCY: number;
  cancelOldTasks: boolean;
}

/**
 * Opportunities API - handles all opportunity-related API calls
 */
export const opportunitiesApi = {
  /**
   * Get all opportunities from BC
   * @returns Promise with list of opportunities
   */
  getAll: async (): Promise<OpportunitiesResponse> => {
    try {
      const response = await apiClient.get<OpportunitiesResponse>(
        "/bc/opportunities"
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching opportunities:", error);
      throw error;
    }
  },

  /**
   * Close an opportunity in BC (mark as won/lost)
   */
  closeOpportunity: async (
    opportunityNo: string,
    payload: CloseOpportunityPayload
  ): Promise<void> => {
    try {
      await apiClient.post(
        `/bc/opportunities/${opportunityNo}/close`,
        payload
      );
    } catch (error) {
      console.error("Error closing opportunity in BC:", error);
      throw error;
    }
  },
};
